export default __webpack_public_path__ + "static/media/respuesta2.3df4c90d.png";